import html2pdf from 'html2pdf.js';

/**
 * Extract Assessment section from markdown
 */
export function extractAssessment(markdown) {
  // Assessment generation/export is disabled for now.
  // Keep function for backward compatibility with existing imports.
  return '';
}

/**
 * Simple markdown to HTML converter
 */
export function convertMarkdownToHTML(markdown) {
  if (!markdown) return '';
  
  let html = markdown;
  html = html.replace(/###\s+(.+)/g, '<h3 style="font-size: 18px; color: #0D5449; margin-top: 20px; margin-bottom: 10px; font-weight: 600;">$1</h3>');
  html = html.replace(/##\s+(.+)/g, '<h2 style="font-size: 20px; color: #0D5449; margin-top: 25px; margin-bottom: 12px; font-weight: 600;">$1</h2>');
  html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/^\* (.+)$/gm, '<li style="margin-bottom: 8px; margin-left: 20px;">$1</li>');
  html = html.replace(/^- (.+)$/gm, '<li style="margin-bottom: 8px; margin-left: 20px;">$1</li>');
  html = html.replace(/^\d+\.\s+(.+)$/gm, '<li style="margin-bottom: 8px; margin-left: 20px; list-style-type: decimal;">$1</li>');
  html = html.replace(/(<li[^>]*>.*<\/li>\s*)+/g, function(match) {
    if (match.includes('list-style-type: decimal')) {
      return '<ol style="margin: 10px 0;">' + match + '</ol>';
    }
    return '<ul style="margin: 10px 0;">' + match + '</ul>';
  });
  html = html.replace(/^(?!<[hl]|<ul|<ol)(.+)$/gm, '<p style="margin: 12px 0; line-height: 1.7;">$1</p>');
  return html;
}

const pdfOpt = {
  margin: [15, 15, 15, 15],
  image: { type: 'jpeg', quality: 0.98 },
  html2canvas: { scale: 2, useCORS: true, letterRendering: true, logging: false },
  jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait', compress: true },
  pagebreak: { mode: ['avoid-all', 'css', 'legacy'], before: '.page-break-before', after: '.page-break-after', avoid: ['table', 'tr', 'img'] }
};

/**
 * Generate and download PDF from a DOM element (lesson plan or quiz)
 */
export async function generatePDF({
  lessonPlan,
  title,
  grade,
  standard,
  concept,
  standardDescription,
  language,
  elementId = 'lesson-plan-content'
}) {
  const element = document.getElementById(elementId);
  if (!element) {
    throw new Error(`Content element with id "${elementId}" not found`);
  }
  const opt = {
    ...pdfOpt,
    filename: `${(title || 'lesson_plan').replace(/[^a-z0-9]/gi, '_').toLowerCase()}.pdf`,
  };
  await html2pdf().set(opt).from(element).save();
  return true;
}

/**
 * Generate and download Assessment PDF
 */
export async function generateAssessmentPDF({
  lessonPlan,
  title,
  grade,
  standard,
  concept,
  standardDescription,
  language
}) {
  // Assessment generation/export is disabled for now.
  throw new Error('Assessment PDF generation is disabled');
}

/**
 * Generate combined PDF API (assessment append disabled; falls back to lesson-plan-only PDF).
 */
export async function generateCombinedPDF({
  lessonPlan,
  title,
  grade,
  standard,
  concept,
  standardDescription,
  language,
  elementId = 'lesson-plan-content'
}) {
  // Keep API, but assessment append behavior is disabled.
  return generatePDF({
    lessonPlan,
    title,
    grade,
    standard,
    concept,
    standardDescription,
    language,
    elementId,
  });
}
